class AccountDrawerController {
  constructor() {
    this.drawer = document.querySelector('[data-account-drawer]');
    this.openTriggers = document.querySelectorAll('#account-icon-drawer');
    if (!this.drawer || !this.openTriggers.length) return;

    this.overlay = this.drawer.querySelector('.account-drawer__overlay');
    this.closeButtons = this.drawer.querySelectorAll('[data-account-drawer-close]');

    this.handleKeydown = this.handleKeydown.bind(this);

    this.openTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault(); // stop navigation to /account
        this.open();
      });
    });

    this.overlay?.addEventListener('click', () => this.close());
    this.closeButtons.forEach((btn) => btn.addEventListener('click', () => this.close()));
  }

  open() {
    this.drawer.classList.add('account-drawer--open');
    document.addEventListener('keydown', this.handleKeydown);
  }

  close() {
    this.drawer.classList.remove('account-drawer--open');
    document.removeEventListener('keydown', this.handleKeydown);
  }

  handleKeydown(event) {
    if (event.key === 'Escape' || event.code === 'Escape') {
      this.close();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new AccountDrawerController();
});
